Object.defineProperty(exports, "__esModule", { value: true });
var ESTransport = /** @class */ (function () {
    function ESTransport() {
    }
    return ESTransport;
}());
exports.ESTransport = ESTransport;
//# sourceMappingURL=ESTransport.js.map